"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenErrors = exports.verifyToken = exports.signToken = exports.decodeToken = void 0;
const jose_1 = require("jose");
function decodeToken(token) {
    return (0, jose_1.decodeJwt)(token);
}
exports.decodeToken = decodeToken;
async function signToken(payload, secret, settings) {
    const ec = new TextEncoder();
    return new jose_1.SignJWT(payload)
        .setProtectedHeader({ alg: (settings === null || settings === void 0 ? void 0 : settings.algorithm) || "HS256" })
        .setExpirationTime((settings === null || settings === void 0 ? void 0 : settings.expiresIn) || "8d")
        .sign(ec.encode(secret));
}
exports.signToken = signToken;
async function verifyToken(token, secret) {
    const ec = new TextEncoder();
    return (await (0, jose_1.jwtVerify)(token, ec.encode(secret))).payload;
}
exports.verifyToken = verifyToken;
exports.TokenErrors = jose_1.errors;
//# sourceMappingURL=tokenUtils.js.map